import React from 'react'
import { Link } from 'react-scroll';
import './Footer.css'

function Footer() {
  return (
    <div className="footer-section">
        <div className="container">
            <div className="footer-content">
                <div className="footer-top">

                    <img src="./images/logo.svg" alt="" />

                    <div className="site-map">
                        <h5>SITE MAP</h5>
                        <div className="site-links">
                            <Link className='link text'
                            activeClass="active" 
                            to="HeroSection" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            > Home
                            </Link>
                            <Link className='link text'
                            activeClass="active" 
                            to="AboutUs" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            >Who We Are
                            </Link>

                            <Link className='link text'
                            activeClass="active" 
                            to="Services" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            >Services
                            </Link>

                            <Link className='link text'
                            activeClass="active" 
                            to="Commitment" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            >Our Commitment
                            </Link>

                            <Link className='link text'
                            activeClass="active" 
                            to="Faq" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            >FAQs
                            </Link>

                            <Link className='link text'
                            activeClass="active" 
                            to="ContactUs" 
                            spy={true} 
                            smooth={true} 
                            duration={500}
                            >Contact Us</Link>
                        </div>    
                    </div>

                    <div className="contact">
                        <h5>CONTACT US</h5>
                        <div className="contact-info">
                            <p className='text'>+234-707-469-0941 <br /> +234-810-881-7253 <br /> +01-63111992</p>
                            <p className='text'>Info@alvacng.com</p>
                            <a 
                            className="link" 
                            href="https://www.linkedin.com/company/alvac-company-limited/?originalSubdomain=ng" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            >
                            LinkedIn
                            </a>

                        </div>    
                    </div>

                    <div className="find">
                        <h5>FIND US</h5>
                        <div className="find-info">
                            <p className='text'>55, Adekunle Fajuyi Way, Ikeja GRA, Lagos.</p>
                            <p className='text'>Mon to Fri 9am to 6pm</p>
                        </div>    
                    </div>

              
                </div>
                <div className="logo-text">
                    <h1>Alvac <span>Limited</span></h1>
                </div>

                <div className="footer-down">
                    <p className='text'>© 2025 — Alvac Company Limited. All Rights Reserved. Copyright</p>
                    <p className='text'>Privacy</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer
